<template>
    <div class="container">
        <div class="card">
            <div class="container">
                <h1>{{langAdvice.title[locale]}}</h1>
                <div class="divider" />
                <div class="container-text">{{langAdvice.adviceText1[locale]}}</div> 
                <hr style="width: 400px; margin: auto; margin-top: 10px; margin-bottom: 10px"/>
                <div class="container-text">{{langAdvice.adviceText2[locale]}}</div>
                <hr style="width: 400px; margin: auto; margin-top: 10px; margin-bottom: 10px"/>
                <div class="container-text">{{langAdvice.disclaimer[locale]}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import langAdvice from '@/store/lang/advice';
import { mapState } from 'vuex';

export default {
    name: "advice",
    computed: mapState({
        locale: state => state.locale
    }),
    data () {
        return {
            langAdvice
        }
    }
}
</script>

<style scoped>
.card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  margin-bottom: 50px;
}

.container {
    padding: 10px;
}

h1{
    font-weight: 900;
}

.divider {
    background-color: #17a2b8; width: 100px; height: 20px; border-radius: 20px; margin: auto; margin-top: 10px; margin-bottom: 10px;
}

.container-text {
    font-size: 2em;
    font-weight: 400;
}
</style>